import React from 'react';
import { Box, Button, TextField, Select, MenuItem, FormControl, IconButton } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useCallback, useMemo, useState, useEffect } from 'react';
import axios from "../../../utils/fvAxios";
import { e } from 'mathjs';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import Nodata from '../../Nodata/Nodata';
import ReactDOM from 'react-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import AddIcon from "@mui/icons-material/Add";
import { useDropzone } from 'react-dropzone';
import Logo from '../../../Media/Upload.jpeg';
import { useTranslation } from "react-i18next";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";


export default function EditClientDownload({ org }) {

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 200,
      },
    },
  };

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [download, setDownload] = useState([]);
  const [intro, setIntro] = useState([]);
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);
  const [fileReset, setFileReset] = useState(true);
  const [selectedValue, setSelectedValue] = useState('');
  const [getheadorfoot, setgetheadorfoot] = useState('');
  const [bus, setbus] = useState('');
  const [bu, setbu] = useState('');

  const activeStyle = {
    borderColor: '#2196f3'
  };

  const acceptStyle = {
    borderColor: '#00e676'
  };

  const rejectStyle = {
    borderColor: '#ff1744'
  };
  const onDrop = useCallback((acceptedFiles) => {
    // Filter acceptedFiles to include only PDF files
    const pdfFiles = acceptedFiles?.filter((file) => file?.type === 'application/pdf');

    if (pdfFiles?.length > 0) {
      // If there are PDF files, update the state with the PDF files and their previews
      setFiles(
        pdfFiles?.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    } else {
      // If no PDF files were dropped, display an alert
      alert('Please drop only PDF files.');
      setFiles([]); // Clear the state
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone({
    onDrop,
    accept: '.pdf', // Use '.pdf' for file extension or 'application/pdf' for MIME type
    maxFiles: 1
  });

  const style = useMemo(() => ({

    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  const thumbs = files?.map(file => (
    <div key={file?.name}>
      {file?.name}
    </div>
  ));
  // clean up
  useEffect(() => () => {
    files?.forEach(file => URL.revokeObjectURL(file?.name));
  }, [fileReset]);

  const [fileName, setFileName] = useState();

  const [Trg, setTrg] = useState(false);
  const [MulticlientInfoCount, setMulticlientInfoCount] = useState(false);

  useEffect(() => {
    axios.get("Companies/GetTemplateDetails?organizationId=" + org
    ).then((res) => {
      if (res?.data?.responseCode === 100) {
        const data = res?.data?.data;
        setIntro(data)
        setSelectedValue(res?.data?.data[0]?.value);
      }
      else {
        setError(res?.data?.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });
  }, [org, Trg]);

  useEffect(() => {
    axios.get("Companies/GetIntroductionSections?templateId=" + selectedValue
    ).then((resp) => {
      if (resp?.data?.responseCode === 100) {
        SetGetIntroductionSections(resp?.data?.data)
      }
      else {
        setError(resp?.data?.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false);
    })
  }, [selectedValue]);

  function handleDocumentClick(event, i) {
    event.preventDefault();
    axios
      .get(
        "Documents/DownloadDocument?idAsFileName=" +
        i?.documentId,
        {
          responseType: 'blob', // Set the response type to blob
        }
      )
      .then((res) => {
        if (res?.data?.type == "application/json") {
          toast.error("File not found", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {

          const file = new Blob([res?.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;

          // const blob = new Blob([res.data], { type: res.headers['content-type'] });
          // const blobUrl = URL.createObjectURL(blob);
          // // Open the Blob URL in a new tab
          // window.open(blobUrl, '_blank');
          // // Revoke the Blob URL after opening to free up resources
          // URL.revokeObjectURL(blobUrl);
        }
      }).catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }



  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    axios.get("Client/GetSubClients?orgId=" + org + "&includeSuperClient=false")
      .then((re) => {
        if (re?.data?.responseCode === 100) {
          setMulticlientInfoCount(re?.data?.count == 0 ? false : true);
        }
      }).catch(err => {
        console.log(err)
      })
  };


  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    axios.get("Companies/GetDocumentsListForClient?organizationId=" + org
    ).then((res) => {
      if (res?.data?.responseCode === 100) {
        const data = res?.data?.data;
        setDownload(data)
      }
      else {
        setError(res?.data?.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setIsLoading(false);
    });

  }, [org, refresh]);


  const [SectionValue, setSectionValue] = useState('0');
  const [email, setEmail] = useState('');
  const [title, setTitle] = useState('');
  const [registration, setRegistration] = useState('1');
  const [downloads, setDownloads] = useState('1');
  const [getIntroductionSections, SetGetIntroductionSections] = useState('');
  const [getHeadersOrFootersOrSubSections, setGetHeadersOrFootersOrSubSections] = useState([]);
  const [getClientBusinessUnitSites, setGetClientBusinessUnitSites] = useState([]);

  const handleClose = () => {
    setOpen(false);
    setFiles([]);
    setEmail('')
    setRegistration(1);

  };

  const handleChange1 = (event) => {
    setSelectedValue(event?.target?.value);

  };
  const handleChange2 = (event) => {
    setgetheadorfoot(event?.target?.value);

  };
  const handleChange3 = (event) => {
    setbu(event?.target?.value);

  };
  const handleChange4 = (event) => {
    setbus(event?.target?.value);

  };



  useEffect(() => {
    if (downloads === "1" || downloads === "4") {
      const down = downloads === "4" ? 31 : 0
      axios.get("Companies/GetHeadersOrFootersOrSubSections?templateSecId=" + getIntroductionSections + "&HeadFootOrSubSecId=-1&headOrFootOrSubSec=" + registration + "&sectionType=" + down + "&clientId=" + org
      ).then((res) => {
        if (res?.data?.responseCode === 100) {
          setGetHeadersOrFootersOrSubSections(res?.data?.data);
          setgetheadorfoot(res?.data?.data[0]?.value);

        }
        else {
          setError(res?.data?.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
    } else if (downloads === "2" || downloads === "3") {
      axios.get("Companies/GetClientBusinessUnitSites?clientId=" + org
      ).then((res) => {
        if (res?.data?.responseCode === 100) {
          setGetClientBusinessUnitSites(res?.data?.data);
          setbu(res?.data?.data?.item2[0]?.key)
          setbus(res?.data?.data?.item3[0]?.businessUnitSiteID)
        }
        else {
          setError(res?.data?.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }, [downloads, getIntroductionSections, registration]); //selectedValue

  const handleSubmit = (event) => {

    event?.preventDefault();

    if (!selectedValue || !downloads || !SectionValue || !email || !registration || !(bu || bus || getheadorfoot)) {
      toast.error("Please fill all the mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    } else if (!files[0]) {
      toast.error("Please Upload a pdf", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      handleClose();
      const formData = new FormData();
      const buvalue = bu ? bu : 0
      const buvalues = bus ? bus : 0
      formData.append('HeadOrFootOrSubSec', registration);
      formData.append('TemplateSectionID', getIntroductionSections);
      formData.append('ClientBusinessUnitId', buvalue);
      formData.append('DisplayOrder', 0);
      formData.append('IsDocTypeNotExist', false);
      formData.append('HeaderOrFooterTitle', "test");
      formData.append('OrganizationID', Number(org));
      formData.append('ClientBusinessUnitsiteId', buvalues);
      formData.append('IntroOrUnit', downloads);
      formData.append('TemplateID', selectedValue);
      formData.append('HeadFootSubSecId', getheadorfoot);
      formData.append('file', files[0]);
      formData.append('File', "test");
      formData.append('FileTitle', email);
      axios
        .post("Companies/AddDocument", formData,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((res) => {
          if (res?.data?.responseCode == "100") {
            toast.success(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setRefresh(!refresh);

            //Field reset
            setTrg(!Trg);
            setDownloads("1")
            setTitle("");
            setEmail("");
            setRegistration("1")
            //Field reset
          } else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

          }

        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

  };

  const [openpop, setOpenpop] = React.useState(false);
  const [EmpId, setEmpId] = React.useState();


  const handleClickOpenpop = (e) => {
    setEmpId(e)
    setOpenpop(true);
  };

  const handlePopClose = () => {
    setOpenpop(false);
    setEmail("");
    setFileReset('')
  };
  const handleDelete = () => {
    setIsLoading(true);
    setOpenpop(false);
    axios
      .get("Companies/DeleteDocument?documentId=" + EmpId?.documentId + "&refType=" + EmpId?.referenceType + "&refRecordId=" + EmpId?.refRecordId + "&orgId=" + org + "&idAsFileName=" + EmpId?.documentId + "&userEnteredFilename=" + EmpId?.documentName,
      )
      .then((res) => {
        if (res?.data?.responseCode == "100") {
          toast.success(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setRefresh(!refresh);
          setEmail("")
        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });


  };
  // const groupedData = getClientBusinessUnitSites?.item3?.reduce((acc, option) => {
  //   if (!acc[option?.businessUnitName]) {
  //     acc[option?.businessUnitName] = [];
  //   }
  //   acc[option?.businessUnitName].push(option);
  //   return acc;
  // }, {});
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />

      <Dialog
        open={openpop}
        keepMounted
        onClose={handlePopClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle> {"Are you sure? you want to permanently delete this content? This operation is irreversible."}</DialogTitle>
        <DialogContent>

        </DialogContent>
        <DialogActions>
          <Button onClick={handlePopClose}>{"Cancel"}</Button>
          <Button onClick={handleDelete}>{t('VendorDetails.label8')}</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogContent sx={{ padding: "48px 48px" }} >
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            <span style={{ fontSize: "larger" }} >Add New Document</span>
          </DialogTitle>

          <DialogActions >
            <div>
              <DialogActions >
                <div>
                  <div className="drop" {...getRootProps({ style })} >
                    <img className='mt-2' src={Logo} alt="" />
                    <br />
                    <input className="mt-2" {...getInputProps()} accept=".pdf" />

                    <span className='text-muted mt-2 fs'><b><span className='mx-1 cl'>{t('DragandDrop.firstLabel1')}</span>
                      { }</b></span>
                    <br />
                    <span className=' text-muted Fs'>
                      {t('Only Pdf Allowed')} <span style={{ color: "red" }}>*</span></span>
                    <span className=' text-muted Fs'> {thumbs}</span>
                  </div>
                  <div className='mt-3' >
                    <span style={{ color: "#3E4A62" }}>Template<span style={{ color: "red" }}>*</span></span>
                    <br />
                    <Select sx={{
                      width: "100%", minWidth: "",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },

                      fontFamily: "Arial, FontAwesome",
                    }}

                      size="small" value={selectedValue} onChange={handleChange1}>
                      {intro?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                          {option?.text}
                        </MenuItem>
                      ))}
                    </Select>

                  </div>


                  <div className='mt-3'>
                    <span style={{ color: "#3E4A62" }}>Dowloads for<span style={{ color: "red" }}>*</span></span>
                    <br />
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={downloads}
                        onChange={(event) => {
                          setDownloads(event?.target?.value)
                          setRegistration("1")
                        }}
                      >
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Introduction"
                        />
                        <FormControlLabel
                          value="4"
                          control={<Radio />}
                          label="PQ Requirements"
                        />
                        <FormControlLabel
                          value="2"
                          disabled={MulticlientInfoCount}
                          control={<Radio />}
                          label="Business Unit"
                        />
                        <FormControlLabel
                          value="3"
                          control={<Radio />}
                          label="Business Unit Sites"
                        />
                      </RadioGroup>

                    </FormControl>
                  </div>
                  <div className='mt-3' hidden={downloads == "2" || downloads == "3"}>
                    <span style={{ color: "#3E4A62" }}>Header / Footer<span style={{ color: "red" }}>*</span></span>
                    <br />
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"

                        value={registration}
                        onChange={(event) => setRegistration(event?.target?.value)}
                      >
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Header"
                        />
                        <FormControlLabel
                          hidden={downloads === "4"}
                          value="2"
                          control={<Radio />}
                          label="Footer"
                        />
                      </RadioGroup>

                    </FormControl>
                  </div>
                  <div className='mt-3' hidden={downloads == "2" || downloads == "3"}>
                    <span style={{ color: "#3E4A62" }}></span>
                    <br />
                    <Select sx={{
                      width: "100%", minWidth: "",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },

                      fontFamily: "Arial, FontAwesome",
                    }}

                      size="small" value={getheadorfoot} onChange={handleChange2}>
                      {getHeadersOrFootersOrSubSections?.map((option) => (
                        <MenuItem key={option?.value} value={option?.value}>
                          {option?.text}
                        </MenuItem>
                      ))}
                    </Select>
                    <br />
                    <div className='mt-3' hidden={getheadorfoot != -1}>
                      <span style={{ color: "#3E4A62" }}>Title</span>
                      <br /><TextField
                        placeholder="Title"
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          width: "100%",
                          backgroundColor: "#fff",
                          marginTop: "2px",
                          marginBottom: "5px",
                        }}
                        value={title || ""}
                        onChange={(e) => setTitle(e?.target?.value)}
                        variant="outlined"
                        size="small"
                      />
                    </div>
                  </div>
                  <div className='mt-3' hidden={downloads == "1" || downloads == "4" || downloads == "3"}>
                    <span style={{ color: "#3E4A62" }}>Business unit<span style={{ color: "red" }}>*</span></span>
                    <br />
                    <Select
                      sx={{
                        width: "100%",
                        minWidth: "",
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      size="small"
                      value={bu}
                      onChange={handleChange3}
                      MenuProps={MenuProps}
                    >
                      {getClientBusinessUnitSites?.item2?.map((option) => (
                        <MenuItem key={option?.businessUnitSiteID} value={option?.key}>
                          {option?.value}
                        </MenuItem>
                      ))}

                    </Select>


                    {/* Use Set to deduplicate values */}
                    {/* {Array.from(new Set(getClientBusinessUnitSites.map(option => option.businessUnitID))).map((uniqueValue) => (
                      <MenuItem key={uniqueValue} value={uniqueValue}> */}
                    {/* You can display the name corresponding to the unique value if needed */}
                    {/* {getClientBusinessUnitSites.find(option => option.businessUnitID === uniqueValue).businessUnitName}
                      </MenuItem>
                    ))} */}

                  </div>
                  <div className='mt-3' hidden={downloads == "1" || downloads == "4" || downloads == "2"}>
                    <span style={{ color: "#3E4A62" }}>Business unit sites<span style={{ color: "red" }}>*</span></span>
                    <br />
                    <Select sx={{
                      width: "100%", minWidth: "",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },

                      fontFamily: "Arial, FontAwesome",
                    }}
                      MenuProps={MenuProps}
                      size="small" value={bus} onChange={handleChange4}>
                      {getClientBusinessUnitSites?.item3?.map((option) => (
                        <MenuItem key={option?.businessUnitSiteID} value={option?.businessUnitSiteID}>
                          {option?.businesUnitsiteName}
                        </MenuItem>
                      ))}
                      {/* {Object?.entries(groupedData)?.map(([businessUnitName, options]) => (
                      <div key={businessUnitName}>
                        <h3>{businessUnitName}</h3>
                        {options?.map((option) => (
                          <MenuItem key={option?.businessUnitSiteID} value={option?.businessUnitSiteID}>
                            {option?.businesUnitsiteName}
                          </MenuItem>
                        ))}
                      </div>
                      ))} */}
                    </Select>

                  </div>
                  <div className='mt-3'>
                    <span style={{ color: "#3E4A62" }}>File Title<span style={{ color: "red" }}>*</span></span>
                    <TextField
                      placeholder="File Title"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "100%",
                        backgroundColor: "#fff",
                        marginTop: "2px",
                        marginBottom: "5px",


                      }}
                      value={email || ""}
                      onChange={(e) => setEmail(e?.target?.value)}
                      variant="outlined"
                      size="small"
                    />
                  </div>
                  <div className='mt-3'>
                    <span style={{ color: "#3E4A62" }}>Display Order<span style={{ color: "red" }}>*</span></span>
                    <br />
                    <TextField
                      placeholder="Display Order"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "100%",
                        backgroundColor: "#fff",
                        marginTop: "2px",
                        marginBottom: "5px",
                      }}
                      variant="outlined"
                      size="small"
                      value={SectionValue || ""}
                      onChange={(e) => {
                        const value = e?.target?.value;

                        // Check if the input is a valid number (integer)
                        if (/^\d+$/.test(value) || value === '') {
                          setSectionValue(value);
                        }
                      }}
                    />



                  </div>

                  <DialogActions >
                    <div className="login-help__buttonContainer mt-4">
                      <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                      <Button variant="contained" className="login-button-request mx-2" onClick={handleSubmit}>Add</Button>
                    </div>

                  </DialogActions>
                </div >
              </DialogActions>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          paddingLeft: "20px",
          paddingRight: "20px",
          "& hr": { mx: 0.5 },
        }}
      >
        <span
          style={{
            marginRight: "auto",
            textDecoration: "none",
            marginTop: "10px",
            marginBottom: "10px",
            color: "#3E4A62",
          }}
        >

        </span>

        {HasPermissions(INFO?.AddNewDocument?.actionName, "I") &&
          <Button variant="contained" onClick={handleClickOpen}>
            <AddIcon /> Add New
          </Button>
        }
      </Box>

      {download?.map((r) => (
        <Box key={r?.category} sx={{ backgroundColor: "#fff", padding: "10px" }}>
          <p style={{ fontSize: "18px", fontWeight: "600", color: "#3E4A62" }}>{r?.category}</p>
          <Box sx={{ backgroundColor: "#F2F4F7", padding: "10px" }}>File</Box>
          <Box sx={{ paddingLeft: "20px", paddingRight: "20px", "& hr": { mx: 0.5 } }}>
            {/* {r?.documents.map((e) => ( */}

            <TableContainer component={Paper} className='mt-4'>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableBody>
                  {r?.documents?.map((e) => (
                    <StyledTableRow key={e?.documentName}  >
                      <StyledTableCell component="th" scope="row" sx={{ padding: 0 }}>
                        <a href="#" className='mx-3' onClick={(event) => handleDocumentClick(event, e)} style={{ textDecoration: "none", color: "#2A93DB", cursor: "pointer" }}>
                          {e?.documentName}
                        </a>
                      </StyledTableCell>

                      <StyledTableCell align="right" sx={{ padding: 0 }}>
                        <IconButton aria-label="Restore" sx={{ color: "#667085" }}>
                          {HasPermissions(INFO?.AddNewDocument?.actionName, PER?.ScreenPermissions?.Delete) &&
                            <DeleteOutlineIcon onClick={() => handleClickOpenpop(e)} />
                          }
                        </IconButton>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* <Box key={e.documentName} sx={{ marginTop: "10px", marginBottom: "10px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <a href="#" onClick={(event) => handleDocumentClick(event, e)} style={{ textDecoration: "none", color: "#2A93DB", cursor: "pointer" }}>
                    {e?.documentName}
                  </a>
                  <IconButton aria-label="Restore" sx={{ color: "#667085" }}>
                    <DeleteOutlineIcon onClick={() => handleClickOpenpop(e)} />
                  </IconButton>
                </Box> 
            ))} */}

          </Box>

        </Box>
      ))}




    </>
  )
}
